import React from 'react';
import { useNavigate } from 'react-router-dom';
import BusinessDecorativeBorder from './common/BusinessDecorativeBorder';
import { Button } from '.';

interface accessModelProps {
    onClose: () => void;
}

const AccessModel: React.FC<accessModelProps> = ({ onClose }) => {

    const navigate = useNavigate();
    return (
        <>
            <div className="fixed inset-0 w-full h-full bg-black bg-opacity-50 z-30" onClick={onClose}></div>
            <div className=" flex flex-col gap-3 lg:gap-4 my-2 font-outfit fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-secondary rounded-xl w-4/5 md:w-2/4 lg:w-2/6 min-w-[300px] p-6 z-40 shadow-lg">
                <div className='flex flex-col gap-1'>
                    <h1 className="text-center text-primary text-xl font-medium ">
                        Upgrade To Premium
                    </h1>
                    <BusinessDecorativeBorder />
                </div>
                <span className='text-md text-center font-outfit font-bold text-textColor my-2'>You are currently on a free plan !<br /> Upgrade to premium to access this feature.</span>
                <div className='flex w-full gap-4 py-6'>
                    <Button name='Cancel' type='cancel' htmlType='submit' onClick={onClose} />
                    <Button name='Upgrade Now' type='update' htmlType='submit' onClick={() => navigate('/home/subscription')} />
                </div>
            </div>
        </>
    )
}

export default AccessModel;